<template>
  <div>
    <el-form-item :label="field.name + '：'" label-width="110px">
      <div class="service-list">
        <draggable v-model="config[field.key]">
          <el-row class="service-item" v-for="(item,index) in config[field.key]" :key="index" type="flex" justify="space-between">
            <div class="link-name" v-text="config[field.key][index]['title']"></div>
            <el-button size="small" @click="removeArticleItem(index)" class="del-btn">删除</el-button>
          </el-row>
        </draggable>
      </div>
      <el-button size="small" @click="openDialog">添加拼团商品／服务</el-button>
    </el-form-item>
    <el-dialog title="请选择拼团活动" :visible.sync="dialog.visible" @close='closeDialog'>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="商品" name="goods"></el-tab-pane>
        <el-tab-pane label="服务" name="service"></el-tab-pane>
      </el-tabs>
      <form-group-list :url="tableList.url" @close='closeDialog' :priceField="tableList.priceField" :searchField="tableList.searchField" :titleField="tableList.titleField" :activityStatusField="tableList.activityStatusField" :params="tableList.params" :resultArrayName="tableList.resultArrayName" :multi="tableList.multi" :idList="idList" @unSelect="unSelect" @select="select"></form-group-list>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.service-list {
  margin-top: -5px;
}
.service-item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}
.del-btn {
  height: 32px;
  margin-top: 4px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";
export default {
  name: "tms-type-form-group-list",
  props: {
    field: {
      type: [Object, Array],
      required: true
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false
      },
      linkNameList: {},
      currentIndex: 0,
      activeName: "goods",
      tableList: {
        url: "wdzg/b/form_group/activity/list",
        resultArrayName: "form_group_activity_list",
        searchField: "name",
        priceField: 'price',
        titleField: 'title',
        activityStatusField: 'lifecycle',
        params: {
          item_type: 1,
          lifecycle: 5
        },
        multi: true
      }
    };
  },

  computed: {
    idList() {
      let list = [];
      this.config[this.field.key].map(val => {
        list.push(val.id);
      });
      return list;
    }
  },

  components: {
    draggable
  },

  created() {},

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    removeArticleItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    /**
     * tab-card切换回调
     * url:               请求的URL
     * searchField:       搜索的字段名称
     * titleName:         列表的标题名称
     * resultArrayName:   返回的数据列表字段名称
     * count:             数据条数
     */
    handleClick() {
      switch (this.activeName) {
        // 拼团商品
        case "goods":
          console.log('goods')
          this.tableList = {
            url: "wdzg/b/form_group/activity/list",
            resultArrayName: "form_group_activity_list",
            searchField: "name",
            priceField: 'price',
            titleField: 'title',
            activityStatusField: 'lifecycle',
            params: {
              item_type: 1,
              lifecycle: 5
            },
            multi: true
          };
          break;
        // 拼团服务
        case "service":
          console.log('service')
          this.tableList = {
            url: "wdzg/b/form_group/activity/list",
            resultArrayName: "form_group_activity_list",
            searchField: "name",
            priceField: 'price',
            titleField: 'title',
            activityStatusField: 'lifecycle',
            params: {
              item_type: 2,
              lifecycle: 5
            },
            multi: true
          };
          break;
      }
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      delete item.rich_detail;
      item.cms_url = "/cms/page/biz/form_group.html?id=" + item.id;
      item.price = Util.filterPriceToFen(item.price);
      this.config[this.field.key].push(item);
    },
    unSelect(row, index) {
      this.config[this.field.key].splice(index, 1);
    }
  }
};
</script>
